<div class="month-picker-wrapper">
    <mat-form-field>
        <input matInput [readonly]="true" [value]="dateControl" [formControl]="dateControl" [matDatepicker]="picker" (click)="picker.open()" [max]="currentDate" [min]="minimumDate"/>
        <mat-datepicker-toggle matSuffix [for]="picker"> <mat-icon matDatepickerToggleIcon svgIcon="expand_more" class="icon-sm ml-4"></mat-icon></mat-datepicker-toggle>
        <mat-datepicker #picker startView="year" (monthSelected)="setMonthAndYear($event, picker)"></mat-datepicker>
    </mat-form-field>
</div>